<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="颜色管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						:kv-filter="kvFilter"
						@doedit="handleEdit($event)"
					></curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, Filters],

	data() {
		return {
			editorDataModel: "Season",
			tableFields: [
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "order",
					sortable: "custom",
				},
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%",
				},
				{
					name: "order",
					sortable: "custom",
				},
			],
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
